import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getDashboardPerformanceData = async (clientId?: number, fromDate?: string, endDate?: string) => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const response = await http.get(`/dashboard/performancemetrics?clientId=${clientId}&fromDate=${fromDate}&toDate=${endDate}`);
    // Return the response
    return response;
}